import React from "react";
import PropTypes from "prop-types";
import Dropdown from "components/elements/dropdown";
import LocationInput from "components/elements/location-input";
import Svg from "components/elements/svg";
import HowItWorksButton from "components/partials/how-it-works-button";
import {
  DEFAULT_FILTERS,
  PROPERTY_TYPES,
  SEARCH_RADIUS,
  PRICE_RANGE,
  NUMBER_OF_BEDROOMS,
  STATUSES,
} from "components/properties/properties-filters.defaults";
import PropertiesFiltersPropTypes from "helpers/prop-types/properties-filters";

export default class PropertyFilters extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...DEFAULT_FILTERS };
  }

  UNSAFE_componentWillMount() {
    const { defaultValue } = this.props;

    if (defaultValue) {
      this.setState({
        ...defaultValue,
      });
    }
  }

  UNSAFE_componentWillReceiveProps({ defaultValue }) {
    if (defaultValue && defaultValue !== this.props.defaultValue) {
      this.setState({ ...defaultValue });
    }
  }

  handleChange(name, value) {
    this.setState({
      [name]: value,
    });
  }

  render() {
    const minNumberOfBedrooms = NUMBER_OF_BEDROOMS.filter((item) => {
      const maxValue = this.state.bedrooms_max;

      return maxValue ? item.value <= maxValue : true;
    });

    const maxNumberOfBedrooms = NUMBER_OF_BEDROOMS.filter((item) => {
      const minValue = this.state.bedrooms_min;

      return minValue ? item.value >= minValue : true;
    });

    const minPriceRange = PRICE_RANGE.filter((item) => {
      const maxValue = this.state.price_range_max;

      return maxValue ? item.value <= maxValue : true;
    });

    const maxPriceRange = PRICE_RANGE.filter((item) => {
      const minValue = this.state.price_range_min;

      return minValue ? item.value >= minValue : true;
    });

    minNumberOfBedrooms.unshift({ value: 0, label: "No min" });
    maxNumberOfBedrooms.unshift({ value: 0, label: "No max" });
    minPriceRange.unshift({ value: 0, label: "No min" });
    maxPriceRange.unshift({ value: 0, label: "No max" });

    return (
      <div
        className={`properties-filters ${
          this.props.collapse ? "collapse" : ""
        }`}
      >
        <div className="properties-filters__form">
          <div className="form-group">
            <div className="form-group-header">
              <label htmlFor="property-type">Property type</label>
              <button
                className="clear-btn inline"
                onClick={() => {
                  this.setState({
                    property_type: DEFAULT_FILTERS.property_type,
                  });
                }}
              >
                Clear <Svg src="x-fat" className="clear-icon" />
              </button>
            </div>
            <Dropdown
              className=""
              options={PROPERTY_TYPES}
              onChange={(value) => this.handleChange("property_type", value[0])}
              value={[this.state.property_type]}
            />
          </div>

          <div className="form-group">
            <div className="form-group-header">
              <label htmlFor="status">Property status</label>
              <button
                className="clear-btn inline"
                onClick={() => {
                  this.setState({
                    status: DEFAULT_FILTERS.status,
                  });
                }}
              >
                Clear <Svg src="x-fat" className="clear-icon" />
              </button>
            </div>
            <Dropdown
              className=""
              options={STATUSES}
              onChange={(value) => this.handleChange("status", value[0])}
              value={[this.state.status]}
            />
          </div>

          <div className="form-group">
            <div className="form-group-header">
              <label htmlFor="location">Location</label>
              <button
                className="clear-btn inline"
                onClick={() => {
                  this.setState({
                    location: DEFAULT_FILTERS.location,
                  });
                }}
              >
                Clear <Svg src="x-fat" className="clear-icon" />
              </button>
            </div>
            <LocationInput
              inputClassName="form-control"
              placeholder="e.g. 'Manchester', 'M4' or 'M4 4DE'"
              onInputChange={(value) => this.handleChange("location", value)}
              value={this.state.location}
            />
          </div>

          <div className="form-group">
            <div className="form-group-header">
              <label htmlFor="radius">Search radius</label>
            </div>
            <Dropdown
              className=""
              options={SEARCH_RADIUS}
              onChange={(value) => this.handleChange("radius", value[0])}
              value={[this.state.radius]}
            />
          </div>

          <div className="form-group">
            <div className="form-group-header">
              <label htmlFor="bedrooms">Number of bedrooms</label>
              <button
                className="clear-btn inline"
                onClick={() => {
                  this.setState({
                    bedrooms_min: DEFAULT_FILTERS.bedrooms_min,
                    bedrooms_max: DEFAULT_FILTERS.bedrooms_max,
                  });
                }}
              >
                Clear <Svg src="x-fat" className="clear-icon" />
              </button>
            </div>
            <div className="row no-gutters">
              <div className="col-xs-6">
                <Dropdown
                  className=""
                  options={minNumberOfBedrooms}
                  onChange={(value) =>
                    this.handleChange("bedrooms_min", value[0])
                  }
                  value={[this.state.bedrooms_min]}
                />
              </div>
              <div className="col-xs-6">
                <Dropdown
                  className=""
                  options={maxNumberOfBedrooms}
                  onChange={(value) =>
                    this.handleChange("bedrooms_max", value[0])
                  }
                  value={[this.state.bedrooms_max]}
                />
              </div>
            </div>
          </div>

          <div className="form-group">
            <div className="form-group-header">
              <label htmlFor="price_range">Price range (£)</label>
              <button
                className="clear-btn inline"
                onClick={() => {
                  this.setState({
                    price_range_min: DEFAULT_FILTERS.price_range_min,
                    price_range_max: DEFAULT_FILTERS.price_range_max,
                  });
                }}
              >
                Clear <Svg src="x-fat" className="clear-icon" />
              </button>
            </div>
            <div className="row no-gutters">
              <div className="col-xs-6">
                <Dropdown
                  className=""
                  options={minPriceRange}
                  onChange={(value) =>
                    this.handleChange("price_range_min", value[0])
                  }
                  value={[this.state.price_range_min]}
                />
              </div>
              <div className="col-xs-6">
                <Dropdown
                  className=""
                  options={maxPriceRange}
                  onChange={(value) =>
                    this.handleChange("price_range_max", value[0])
                  }
                  value={[this.state.price_range_max]}
                />
              </div>
            </div>
          </div>
          <button
            className="clear-btn"
            onClick={() => this.props.onChange(null)}
          >
            Clear all filters <Svg src="x-fat" className="clear-icon" />
          </button>
          <button
            className="btn btn-primary btn-block"
            onClick={() => this.props.onChange(this.state)}
          >
            Filter results
          </button>
        </div>
        <HowItWorksButton />
      </div>
    );
  }
}

PropertyFilters.propTypes = {
  onChange: PropTypes.func.isRequired,
  collapse: PropTypes.bool.isRequired,
  defaultValue: PropertiesFiltersPropTypes,
};

PropertyFilters.defaultProps = {
  defaultValue: DEFAULT_FILTERS,
  collapse: false,
};
